<script lang="ts">
    import type InstagramStoryEntity from "@apps/instagram/entities/InstagramStoryEntity";
    import { getTypedContext } from "@lib/svelte-typed-context";
    import CN from "classnames";
    import { createEventDispatcher } from "svelte";

    import Image from "@components/Image/Image.svelte";
    import { ModalToken } from "@components/Modal/ModalManager";
    import { modalManagerContextKey } from "@components/Modal/ModalManager/constants";

    export let story: InstagramStoryEntity;
    export let instagramStoriesModalToken: ModalToken<{ id: number }>;
    let loaded = false;
    const modalManager = getTypedContext(modalManagerContextKey);

    const handleOpen = () => {
        modalManager.openModal(instagramStoriesModalToken, undefined, {
            id: story.id,
        });
    };

    let dispatch = createEventDispatcher();
    const imageLoaded = () => {
        dispatch("imageLoaded");
        loaded = true;
    };
</script>

<div
    class="gw-ig-story-card gw-ig-story-card--square"
    on:click={handleOpen}
    on:keydown={handleOpen}
>
    <div
        class={CN("gw-ig-story-card__content", {
            "gw-ig-story-card__border": loaded,
            "gw-ig-story-card__border--viewed": loaded,
        })}
    >
        <Image
            imgClassName={"gw-ig-story-card__image"}
            backdropClassName="gw-ig-story-card__backdrop"
            src={story.photoUrl}
            alt={story.id.toString()}
            ratio={1 / 1}
            objectFit="cover"
            on:imageLoaded={imageLoaded}
        />
    </div>
</div>

<style>
    .gw-ig-story-card {
        position: relative;
        width: 100%;
        height: 100%;
        cursor: pointer;
    }

    .gw-ig-story-card--square {
        height: unset;
    }

    .gw-ig-story-card--square::after {
        content: "";
        display: block;
        padding-bottom: 100%;
    }

    .gw-ig-story-card--square .gw-ig-story-card__content {
        position: absolute;
        box-sizing: border-box;
        width: 100%;
        height: 100%;
        padding: 2px;
        border-radius: 50%;
    }

    .gw-ig-story-card__border {
        background: radial-gradient(
            ellipse at 70% 70%,
            #ee583f 8%,
            #d92d77 42%,
            #bd3381 58%
        );
    }

    .gw-ig-story-card__border--viewed {
        background: #999;
    }

    :global(.gw-ig-story-card__image) {
        box-sizing: border-box;
        width: 100%;
        height: 100%;
        border: 3px solid #fff;
        border-radius: 50%;
        object-fit: cover;
    }

    :global(.gw-ig-story-card__backdrop) {
        border-radius: 50%;
    }
</style>
